import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  StyledImgAvatar,
  StyledFirstChar,
  StyledImg,
  StyledLink
} from './style';
import { initialsString } from '../../../utils/initialsString';
import { SQUARED_SMALL } from '../../../utils/crops';
import { accentsTidy } from '../../../utils/accents';
import { isPhoto, updateAvatarHeaderImage } from '../../../utils/apiUser';

const AvatarPerson = ({
  className,
  name,
  lastname,
  userId,
  avatarPhoto,
  timeStamp,
  full,
  directory,
  linkProfile
}) => {
  let firstLetter;
  let secondLetter;
  const [image, setImage] = useState(null);
  const [timestamp, setTimestamp] = useState(null);
  const [photo, setPhoto] = useState(avatarPhoto);
  if (name) {
    firstLetter = accentsTidy(initialsString(name, 1));
  }
  if (lastname) {
    secondLetter = accentsTidy(initialsString(lastname, 1));
  }

  useEffect(() => {
    if (timestamp !== timeStamp) {
      setTimestamp(timeStamp);
    }
  }, [timeStamp]);

  useEffect(() => {
    Promise.resolve(isPhoto(userId))
      .then(() => {
        setImage(updateAvatarHeaderImage(userId));
      })
      .catch(() => setPhoto(undefined));
  }, []);

  const renderAvatarPerson = () =>
    !photo ? (
      <StyledFirstChar full={full} className="avatar-char">
        {`${firstLetter}${secondLetter}`}
      </StyledFirstChar>
    ) : (
      <StyledImg
        src={image}
        loading="lazy"
        directory={directory}
        full={full}
        onError={({ e }) => {
          if (e?.target) {
            e.target.onerror = null;
          }
          setPhoto(undefined);
        }}
      />
    );

  return (
    <StyledImgAvatar className={className} defaultCrop={SQUARED_SMALL}>
      {linkProfile && userId !== '99999999' ? (
        <StyledLink
          href={`/perfil/${userId}/mi_perfil`}
          title={`Ver perfil de ${name}`}
          rel="noopener noreferrer"
        >
          {renderAvatarPerson()}
        </StyledLink>
      ) : (
        renderAvatarPerson()
      )}
    </StyledImgAvatar>
  );
};

AvatarPerson.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  lastname: PropTypes.string,
  crop: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),
  userId: PropTypes.string,
  avatarPhoto: PropTypes.bool,
  timeStamp: PropTypes.number
};

AvatarPerson.defaultProps = {
  name: ''
};

export default AvatarPerson;
